'use strict';

/**
 * Service: Order
 *
 * @version
 * 13.5.0 MLIBJS-166 Remove unused ordering-api GET/PUT methods in wdOrderService
 * 12.10.0 MLIBJS-137 Add order and fulfillment group parsing for manufacturing format
 * 12.4.0 #756 MLIBJS-121 Add validation to export wdOrderService for ES6 usage
 * 9.0.0 #701 MLIBJS-75 Remove deprecated services
 * 8.14.5 #653 MLIBJS-29 Add Change Order Status Functionality
 * 7.4.0 #470 Refactor changes to status and fulfilment group statuses
 * 7.4.0 #467 Refactor parseOrderDetails from wdOrderService to AdapterOrder
 * 7.2.0 #449 Refactor wdOrder to wdOrderService
 * 7.2.0 #450 Missing formatting in order listing view
 * 7.1.2 #444 Add method for getting orders by delivery date to wdOrder service
 * 7.0.0 #432 Refactor MiniMongoClient to use Adapter Pattern
 * 7.0.0 #433 Adapt Main Library for Custom Statuses
 * 6.0.4 #417 Order Service: Add Archive Functionality
 * 6.0.0 #411 Add functionality to calculate remaining fabrication time
 * 5.9.1 #404 Order date formatting doesn't work on iPads
 * 5.9.0 #402 Minor Tweaks
 * 5.9.0 #401 Special Instructions isn't working
 * 5.9.0 #399 Add getRowClassByStatus
 * 5.9.0 #397 Refactor based on API standardisation
 * 5.9.0 #396 Adapt wdStatusService to allow for calendar type separation
 * 5.9.0 #395 Adapt wdOrderService for separation of Production and Delivery dates
 * 5.8.0 #392 Add Submit Order to Main Library Order Service
 * 5.6.7 #374 Add check for order items in wdOrder
 * 5.6.3 #363 Remove orderNumber when calling GET /orders/actives
 * 5.6.2 #361 Refactor wdOrder service to pass in order number
 * 5.5.6 #348 Refactor wdOrder service to handle empty fulfillment groups
 * 5.3.0 #311 Add 'search_value'
 * 5.0.1 #286 Standardise Data Loading and Parsing Services
 * 5.0.1 #278 Re-factor for Dashboard
 * 3.2.0 #261 Unit Test Coverage, Tidy
 * 2.3.0 #239 Update Parse Orders to Allow Attachments
 * 2.2.0 #237 Refactor to remove "records" when getting orders
 * 1.8.1 #204 Extend wdOrder to allow for Calendar Second Sort
 *
 * @author Dallas Vogels <dvogels@webduct.com>
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @author Erik Orozco <eorozco@intersog.com>
 * @author Deitric Jang <djang@buildcentrix.com>
 *
 * @copyright (c) 2014-2023 Build Centrix
 */
var wdOrderService = angular.module('wd.service.order', [])
    .factory(
        'wdOrderService',
        [
            'wdOauth2HttpService', '$q', 'wdApiResponseHandler', 'wdFulfillmentGroupService',
            'wdSharedFunctionsService', 'wdStatusService', 'wdOrderHelper',
            function (wdOauth2HttpService, $q, wdApiResponseHandler, wdFulfillmentGroupService,
                      wdSharedFunctionsService, wdStatusService, wdOrderHelper)
            {
                // Initialize Service
                var service = {};

                //Clear current results
                service.orders = [];
                service.orderAttachments = [];
                service.orderCount = 0;
                service.orderDetails = {};
                service.orderFulfillmentGroups = [];
                service.orderPricing = {};

                // Variables
                var orderingApiUrl;

                /**
                 * Build Fabrication Times for Order
                 *
                 * @since 6.0.0
                 * @param {object} order
                 * @returns {*}
                 */
                service.buildFabricationTimesForOrder = function(order){
                    return wdOrderHelper.buildFabricationTimesForOrder(order);
                };

                /**
                 * Calculate the REMAINING Fabrication Times Based on (Parsed) Order Fulfilment Groups
                 *
                 * @since 6.0.0
                 *
                 * @param {array} fulfillmentGroups
                 * @returns {number}
                 */
                service.calculateRemainingFabricationTimeAsFloat = function(fulfillmentGroups) {
                    return wdOrderHelper.calculateRemainingFabricationTimeAsFloat(fulfillmentGroups);
                };

                /**
                 * Calculate the TOTAL fabrication Time Based on (Parsed) Order Fulfilment Groups
                 *
                 * @since 6.0.0
                 *
                 * @param {array} fulfillmentGroups
                 * @returns {number}
                 */
                service.calculateTotalFabricationTimeAsFloat = function(fulfillmentGroups) {
                    return wdOrderHelper.calculateRemainingFabricationTimeAsFloat(fulfillmentGroups);
                };

                /**
                 * Get Overall Status based on Fulfilment Groups
                 *
                 * @since 5.0.1
                 *
                 * @param {Object} fulfillmentGroups
                 * @returns {String} overallStatus
                 */
                service.getOrderStatus = function(fulfillmentGroups) {
                    return wdOrderHelper.getOrderStatus(fulfillmentGroups);
                };

                /**
                 * Get Row Class by Status
                 *
                 * @since 5.9.0
                 * @param {string} overallStatus
                 * @returns {string}
                 */
                service.getRowClassByStatus = function(overallStatus) {
                    return wdOrderHelper.getRowClassByStatus(overallStatus);
                };

                /**
                 * Parse and Standardise Orders for Display
                 *
                 * @since 7.4.0
                 * @param {{}} order
                 * @returns {object}
                 */
                service.parseOrderDetails =  function(order) {
                    return wdOrderHelper.parseOrderDetails(order);
                };

                /**
                 * Parse and Standardise Orders for Display
                 *
                 * @since 5.0.1
                 *
                 * @param {Array} orders
                 * @param {String} format
                 * @returns {Array}
                 */
                service.parseOrders = function(orders, format) {
                    var parsedOrders;

                    // Check which format the orders are in for parsing
                    if (format === 'manufacturing') {       // modern format for orders (e.g. includes adjustments)
                        parsedOrders = wdOrderHelper.parseOrdersManufacturing(orders);
                    } else {    // the default older order format
                        parsedOrders = wdOrderHelper.parseOrders(orders);
                    }
                    return parsedOrders;
                };

                /**
                 * Set Ordering Api Url
                 *
                 * @since 5.0.1
                 * @param {String} url
                 * @returns {boolean}
                 */
                service.setOrderingApiUrl = function (url) {

                    orderingApiUrl = url;
                    return true;

                };

                /**
                 * Submit Order
                 *
                 * @since 5.8.0
                 * @param {{}} data
                 * @returns {*}
                 */
                service.submitOrder = function(data)
                {
                    var url = orderingApiUrl + 'orders';

                    // Add the header for content-type - Required when uploading files as the uploader creates a multi-part
                    // header with a boundary and populates the Content-Type:
                    // e.g. multipart/form-data; boundary=----WebKitFormBoundary7dXJO4cfq8XeIAf5
                    wdOauth2HttpService.addHeader('Content-Type', undefined);
                    var result = wdOauth2HttpService.post(url, data);
                    wdOauth2HttpService.deleteHeader('Content-Type');

                    // Make the post
                    return result;

                };

                // Return Service
                return service;

            }
        ]
    );
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdOrderService;
}
// EOF
